export const moduleName = 'coupon';